import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, Transitions } from "../types"

export const getLessonPreviewTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "getLessonPreview",
    onDone: [
      {
        target: "#StudyPlan.edit_plan.go_back_to_previous",
        actions: "openNewTabToPreviewLesson"
      }
    ],
    onError: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("getLessonPreview", {
            messageData: ["modify hours"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
